/**
 * Nombre del evento Meta: mismo valor en fbq('track', ...) y en CAPI (event_name).
 */
export const META_PURCHASE_EVENT_NAME = 'Purchase';

/** customer_type único (ya no hay distinción mayorista/minorista). */
export const META_CUSTOMER_TYPE = 'cliente';

/** content_category del pixel / CAPI. */
export const META_CONTENT_CATEGORY = 'venta';

export function metaContentCategoryFromCustomerType() {
  return META_CONTENT_CATEGORY;
}
